module.exports = __webpack_public_path__ + "img/cover-tablet.ec8ed1a0.jpg";